import { graphql } from '@apollo/client/react/hoc';
import gql from 'graphql-tag';

const query = gql`
{
  configurator @client {
    globals {
      showModal
    }
  }
}
`;

const mapDataToProps = result => ({
  showModal: result?.data?.configurator?.globals?.showModal
});

const withShowModalFlag = graphql(query, {
  props: mapDataToProps
});

export default withShowModalFlag;
